import * as CorporateCaseCountAction from './action';
const initialState = {
    corporateList: [],
    corporateListError: [],
    corporateCaseCountPaginatedData: [],
    corporateCaseCountFailure: []
}

const CorporateCaseCountReducer = (state = initialState, action) => {
    switch (action.type) {
        case CorporateCaseCountAction.LIST_CORPORATE_SUCCESS:
            return state = {
                ...state,
                corporateList: action.data
            }
        case CorporateCaseCountAction.LIST_CORPORATE_FAILURE:
            return state = {
                ...state,
                corporateListError: action.error
            }
        case CorporateCaseCountAction.FETCH_CORPORATE_CASE_COUNT_SUCCESS:
            return state = {
                ...state,
                corporateCaseCountPaginatedData: action.data
            }
        case CorporateCaseCountAction.FETCH_CORPORATE_CASE_COUNT_FAILURE:
            return state = {
                ...state,
                corporateCaseCountFailure: action.data
            }
        default: return state;
    }
}
export default CorporateCaseCountReducer;